export const AUTH_TOKEN_KEY = "authToken";
export const MENU_ITEMS_KEY = "menuItems";
export const UNREAD_MESSAGES_KEY = "unreadMessages";
export const PASSWORD_STATUS_KEY = "passwordStatus";
export const EMPTY_UUID = "00000000-0000-0000-0000-000000000000";

/** AppBar ve Drawer header aynı yükseklikte hizalanır */
export const LAYOUT_HEADER_HEIGHT = 80;
